import { ChartType } from '../../../proto/generated/chart'

export type PrimaryMetadataFields = {
    showOpen: boolean
    showHigh: boolean
    showLow: boolean
    showClose: boolean
    showValue: boolean
    showBarChange: boolean
    closeLabel: string
}

type StatusLinePrefs = {
    showOHLC?: boolean
    showBarChange?: boolean
}

export const getPrimaryMetadataFields = (
    chartType: ChartType,
    statusLine?: StatusLinePrefs
): PrimaryMetadataFields => {
    const showOHLC = statusLine?.showOHLC ?? true
    const showBarChange = statusLine?.showBarChange ?? true

    switch (chartType) {
        case ChartType.LINE:
        case ChartType.LINE_WITH_MARKERS:
        case ChartType.STEP_LINE_CHART:
        case ChartType.AREA:
        case ChartType.BASELINE:
            return {
                showOpen: false,
                showHigh: false,
                showLow: false,
                showClose: false,
                showValue: showOHLC,
                showBarChange,
                closeLabel: '',
            }
        case ChartType.HIGH_LOW:
            return {
                showOpen: false,
                showHigh: showOHLC,
                showLow: showOHLC,
                showClose: false,
                showValue: false,
                showBarChange,
                closeLabel: '',
            }
        case ChartType.HLC_AREA:
            return {
                showOpen: false,
                showHigh: showOHLC,
                showLow: showOHLC,
                showClose: showOHLC,
                showValue: false,
                showBarChange,
                closeLabel: 'C',
            }
        default:
            return {
                showOpen: showOHLC,
                showHigh: showOHLC,
                showLow: showOHLC,
                showClose: showOHLC,
                showValue: false,
                showBarChange,
                closeLabel: 'C',
            }
    }
}
